import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyBookingSlidebarMenuComponent } from './my-booking-slidebar-menu.component';
import { StaticMsgModule } from '@lib/pipes';
import { TealiumModule } from '@common/components/tealium/tealium.module';
import { PassengerNameModule } from '@common/pipes';
import { PassAmcInformationStoreServiceModule } from '@common/services/pass-amc-information-store/pass-amc-information.module';

@NgModule({
  declarations: [MyBookingSlidebarMenuComponent],
  imports: [CommonModule, StaticMsgModule, TealiumModule, PassengerNameModule, PassAmcInformationStoreServiceModule],
  exports: [MyBookingSlidebarMenuComponent],
})
export class MyBookingSlidebarMenuModule {}
